module.exports = __webpack_public_path__ + "img/EWP.c81e65ee.png";